@if (auth.isAuthenticated$() | async; as authenticated) {
	@if (authenticated) {
		<button [disabled]="!isOnline" ngbDropdownItem *ngIf="auth.user() | async as user" type="button" class="btn btn-secondary" (click)="onLogout()">
			<bi name="box-arrow-right"></bi>&nbsp;<span>Abmelden</span>
		</button>
	} 
	@else {
		<button ngbDropdownItem type="button" class="btn btn-secondary" (click)="openLogin()">
			<bi name="person-circle"></bi>&nbsp;<span>Anmelden</span>
		</button>
	}
}
@else {
	<button *ngIf="!auth.currentUser" [disabled]="!isOnline" ngbDropdownItem type="button" class="btn btn-secondary" (click)="openLogin()">
		<bi name="person-circle"></bi>&nbsp;<span>Anmelden</span>
	</button>
	<button *ngIf="auth.currentUser" [disabled]="!isOnline" ngbDropdownItem type="button" class="btn btn-secondary" (click)="onLogout()">
		<bi name="person-circle"></bi>&nbsp;<span>Abmelden</span>
	</button>
}
